<template>
  <config-base-delta class="opc-lm-edit" ref="baseRef" :on="$listeners" @view-details="showPlanDetailDialog"
                     show-plan-details
                     :plan-details-label="$t('billing.delta.cur_plan_detail')">
    <template #config>
      <delta-edit-main :planType="planType" :max-to-add="maxToAdd" :sub-title="subTitle" :unit="unit" />
    </template>
  </config-base-delta>
</template>

<script>

import ConfigBase from "@/components/config-base.vue";
import DeltaEditMain from "@/components/delta-edit-main.vue";
import ViewCurrentDialog from "@/components/view-current-dialog";

import { ServiceConfirm } from "@/components/common/service-dialog/confirm";
import commonMixin from "@/plans/ZOOM_ONE_BUNDLE/mixin/mixin";
import { mapGetters } from "vuex";
import { PBX_REGIONS, regions } from "@/plans/ZOOM_PHONE/helper/constants";
import { DEFAULT_MAX_HOST } from "@/common/constants";

const ConfigBaseDelta = {
  extends: ConfigBase,
  mixins: [commonMixin],
  props: {
    showPlanDetails: Boolean,
    planDetailsLabel: String,
  },
  data() {
    return {
      showLearnMore: false,
    };
  },
};

export default {
  name: "EditDelta",
  mixins: [commonMixin],
  data() {
    return {
      viewCurrentDialog: null,
    };
  },
  components: {
    ConfigBaseDelta,
    DeltaEditMain,
  },
  created() {
    this.viewCurrentDialog = new ServiceConfirm(ViewCurrentDialog);
  },
  computed: {
    ...mapGetters(["getSelectedPlans", "boughtPlans"]),
    currentSelectedPlan() {
      return this.getSelectedPlans.find(p => p.type === this.planType);
    },
    subTitle() {
      const regionLabel = this.currentSelectedPlan.region === PBX_REGIONS.GLOBAL ?
        "billing.pbx.global_select" : regions.find(r => r.key === this.currentSelectedPlan.region)?.label;
      return this.$t("billing.delta.buy_more_licenses_with_plan_name",
        { planName: this.$t("billing.planform.title.biz_plus") + " " + this.$t(regionLabel) });
    },
    unit() {
      return this.$t("billing.planform.title.biz_plus") + " " + this.$t("billing.planform.unit.license");
    },
    maxToAdd() {
      const boughtPlan = this.boughtPlans.find(p => p.plan_code === this.currentSelectedPlan.plan_code);
      const boughtLicense = boughtPlan?.cartInfo?.selected_number;
      const max = boughtLicense > DEFAULT_MAX_HOST ? boughtLicense : DEFAULT_MAX_HOST;
      return max - boughtLicense;
    },
  },
  methods: {
    showPlanDetailDialog() {
      this.viewCurrentDialog.confirm({
        planType: this.planType,
      }).catch((e) => {
        console.error(e);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-lm-edit {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
